import React from "react";
import ReactDOM from "react-dom";

interface LoaderProps {
    color?: string;
    fullscreen?: boolean;
    size?: number;
}

const Loader: React.FC<LoaderProps> = ({
    color = "#ffa516",
    fullscreen = true,
    size = 50
}) => {
    const loaderStyle: React.CSSProperties = {
        width: `${size}px`,
        aspectRatio: "1",
        borderRadius: "50%",
        background: `
            radial-gradient(farthest-side, ${color} 94%, transparent) top/${size * 0.16}px ${size * 0.16}px no-repeat,
            conic-gradient(transparent 30%, ${color})
        `,
        WebkitMask: `radial-gradient(farthest-side, transparent calc(100% - ${size * 0.16}px), #000 0)`,
        mask: `radial-gradient(farthest-side, transparent calc(100% - ${size * 0.16}px), #000 0)`,
        animation: "loaderSpin 1s infinite linear"
    };

    const fullscreenStyle: React.CSSProperties = {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999
    };

    const centeredStyle: React.CSSProperties = {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: "100%",
    };

    if (fullscreen) {
        return ReactDOM.createPortal(
            <>
                <style>{`
                    @keyframes loaderSpin {
                        100% { transform: rotate(1turn); }
                    }
                `}</style>
                <div style={fullscreenStyle}>
                    <div style={loaderStyle}></div>
                </div>
            </>,
            document.body
        );
    }

    return (
        <>
            <style>{`
                @keyframes loaderSpin {
                    100% { transform: rotate(1turn); }
                }
            `}</style>
            <div style={centeredStyle}>
                <div style={loaderStyle}></div>
            </div>
        </>
    );
};

export default Loader;